export const renderDepthOffset = 20
export const NEW_BLOCK_THRESHOLD_MONTHS = 1 // months
